import { Suspense, useContext } from "react";
import { useBjelinTranslations } from "../../hooks/TranslationHooks";
import {
  useCurrentUser,
  UserContext
} from "../../functional-components/UserContext";
import { Link } from "react-router-dom";
import CmsLink from "../../components/CmsLink";
import ContactInfo from "../../components/ContactInfo";
import MobileLinkAccordion from "../../components/MobileLinkAccordion";
import { accountPageUrl, homeUrl, loginUrl } from "../../config/urls";
import { useSiteFeatures } from "../../hooks/useSiteFeatures";
import "./style.scss";
import Icon from "../../components/Icon";
import { useLocSettings } from "../../hooks/SettingsHooks";
import { Spinner } from "reactstrap";

const FooterInner = () => {
  const t = useBjelinTranslations();
  const features = useSiteFeatures();
  const userContext = useContext(UserContext);
  const { authenticated, admin } = useCurrentUser();
  const { footer } = useLocSettings();
  const footerLinks = () => {
    const footerLinks = (footer.link_groups || []).map(group => {
      const title = group.name;
      const links = group.links.map(link => (
        <CmsLink key={link.url} url={link.url} text={link.text} />
      ));
      return { title, links };
    });

    const accountLinks = [];
    if (authenticated) {
      if (features.login()) {
        accountLinks.push(<Link to={accountPageUrl}>{t("your.account")}</Link>);
      }
      accountLinks.push(
        <Link to={homeUrl} onClick={userContext.signOut}>
          {t("footer.logout")}
        </Link>
      );
    } else if (features.login()) {
      accountLinks.push(<Link to={loginUrl}>{t("footer.login")}</Link>);
    }

    if (features.login() || admin) {
      footerLinks.push({
        title: t("footer.account"),
        links: accountLinks
      });
    }

    return footerLinks;
  };

  const socialIcons = () => {
    const facebookUrl = footer.facebook_url;
    const instagramUrl = footer.instagram_url;
    const pinterestUrl = footer.pinterest_url;
    return (
      <div className={"social-icons"}>
        {facebookUrl && (
          <a className={"facebook"} href={facebookUrl} title="Facebook">
            <Icon name="facebook-f" type="fab" size="2x" />
          </a>
        )}
        {instagramUrl && (
          <a className={"instagram"} href={instagramUrl} title="Instagram">
            <Icon name="instagram" type="fab" size="2x" />
          </a>
        )}
        {pinterestUrl && (
          <a className={"pinterest"} href={pinterestUrl} title="Pinterest">
            <Icon name="pinterest" type="fab" size="2x" />
          </a>
        )}
      </div>
    );
  };

  return (
    <>
      <div className={"footer-content"}>
        {footerLinks().map(({ title, links }, i) => (
          <div className={"link-group"} key={i}>
            <h4>{title}</h4>
            <ul>
              {links.map((link, j) => (
                <li key={j}>{link}</li>
              ))}
            </ul>
          </div>
        ))}
        <ContactInfo className={"contact-info mb-3"} />
        {socialIcons()}
      </div>
      <div className={"mobile-footer-content"}>
        <MobileLinkAccordion groups={footerLinks()} />
        <div className="text-center">
          <ContactInfo className={"contact-info mb-3"} />
          {socialIcons()}
        </div>
      </div>
    </>
  );
};

const Footer = () => {
  return (
    <nav aria-label="Footer" className={"footer"}>
      <div className={"footer-container"}>
        <Suspense fallback={<Spinner />}>
          <FooterInner />
        </Suspense>
      </div>
    </nav>
  );
};

export default Footer;
